angular
  .module('company')

  .directive('selectDocumentSector', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        sector: '=',
        macrosector: '=',
        type: '@',
        onChange: '&'
      },
      template:
        '<select ng-model="sector" ng-options="s.value for s in documents track by s._id" ng-change="save()">' +
        '<option value="">-</option>' +
        '</select>',
      controller: [
        '$scope',
        '$controller',
        '$timeout',
        'DocumentCrud',
        function($scope, $controller, $timeout, DocumentCrud) {
          $controller('ListCtrl', {
            $scope: $scope,
            crud: new DocumentCrud('-list'),
            packageName: 'document',
            dataName: 'documents',
            filters: {
              type: $scope.type
            }
          });

          $scope.$watch('macrosector', function(newValue, oldValue) {
            if (newValue) {
              $scope.loadList({ parent: newValue._id });
            }
          });

          $scope.save = () =>
            $timeout(() => $scope.onChange && $scope.onChange());
        }
      ]
    };
  });
